import { compose } from 'recompose';
import { addProps, addIntlProps } from 'utils/recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import combineSelectors from 'utils/combineSelectors';
import { theme, mini } from 'reducers/dashboard/selectors';
import messages from './messages';
import bmwSrcDetailIcon from './icons/ic-detail.svg';
import bmwSrcRemoveIcon from './icons/ic-remove.svg';
import bmwSrcDuplicateIcon from './icons/ic-duplicate.svg';
import miniSrcDetailIcon from './icons/mini_ic_detail.svg';
import miniSrcRemoveIcon from './icons/mini_ic_remove.svg';
import miniSrcDuplicateIcon from './icons/mini_ic_duplicate.svg';

const mapStateToProps = combineSelectors({
  theme,
  mini,
});

export const textStyle = ({ theme }) => ({ color: theme.dropDownText });

export const srcDetailIcon = ({ mini }) =>
  mini ? miniSrcDetailIcon : bmwSrcDetailIcon;

export const srcRemoveIcon = ({ mini }) =>
  mini ? miniSrcRemoveIcon : bmwSrcRemoveIcon;

export const srcDuplicateIcon = ({ mini }) =>
  mini ? miniSrcDuplicateIcon : bmwSrcDuplicateIcon;

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['detailString', 'removeString', 'duplicateString'],
  }),
  connect(mapStateToProps),
  addProps({ textStyle }),
  addProps({ srcDetailIcon, srcRemoveIcon, srcDuplicateIcon }),
);
